"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __elasticsearch_1 = require("../../../__elasticsearch");
exports.ElasticsearchIndicesUrlMapping = {
    state: __elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL,
    assignmentEvent: __elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL,
    stateInteraction: __elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL,
    contentsession: __elasticsearch_1.ElasticsearchURLEnum.ES_AZURE_URL,
    content: __elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL,
    live_class: __elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL,
    live_class_events: __elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL,
    liveClass: __elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL,
    dashboard: __elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL,
    group: __elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL,
    users: __elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL,
    contentVersionLogs: __elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL
};
var ElasticsearchIndicesEnum;
(function (ElasticsearchIndicesEnum) {
    ElasticsearchIndicesEnum["STATE"] = "state";
    ElasticsearchIndicesEnum["DASHBOARD"] = "dashboard";
    ElasticsearchIndicesEnum["GROUPS"] = "groups";
    ElasticsearchIndicesEnum["ASSIGNMENT_EVENT"] = "assignmentevent";
    ElasticsearchIndicesEnum["STATE_INTERACTION"] = "stateinteraction";
    ElasticsearchIndicesEnum["CONTENTSESSION"] = "contentsession";
    ElasticsearchIndicesEnum["USER"] = "users";
    ElasticsearchIndicesEnum["OFFERS"] = "offers";
    ElasticsearchIndicesEnum["CONTENT_VERSION_LOG"] = "content_version_log";
    ElasticsearchIndicesEnum["LIVE_CLASS"] = "liveClasses";
    ElasticsearchIndicesEnum["LYEARN_LIVE_CLASS"] = "live_class";
    ElasticsearchIndicesEnum["LIVE_CLASS_EVENTS"] = "live_class_events";
})(ElasticsearchIndicesEnum = exports.ElasticsearchIndicesEnum || (exports.ElasticsearchIndicesEnum = {}));
var ElasticsearchTypesEnum;
(function (ElasticsearchTypesEnum) {
    ElasticsearchTypesEnum["STATE"] = "state";
    ElasticsearchTypesEnum["DASHBOARD"] = "dashboard";
    ElasticsearchTypesEnum["STATE_INTERACTIONS"] = "stateinteractions";
    ElasticsearchTypesEnum["ASSIGNMENT_EVENT"] = "assignmentevent";
    ElasticsearchTypesEnum["GROUP"] = "group";
    ElasticsearchTypesEnum["OFFER"] = "offer";
    ElasticsearchTypesEnum["PATH"] = "curriculum";
    ElasticsearchTypesEnum["USER"] = "user";
    ElasticsearchTypesEnum["LIVE_CLASS"] = "class";
    ElasticsearchTypesEnum["CONTENT_VERSION_LOG"] = "content_version_log";
    ElasticsearchTypesEnum["LYEARN_LIVE_CLASS"] = "live_class";
    ElasticsearchTypesEnum["LIVE_CLASS_EVENTS"] = "live_class_events";
})(ElasticsearchTypesEnum = exports.ElasticsearchTypesEnum || (exports.ElasticsearchTypesEnum = {}));
var ElasticsearchFilterTypeEnum;
(function (ElasticsearchFilterTypeEnum) {
    ElasticsearchFilterTypeEnum["MUST"] = "must";
    ElasticsearchFilterTypeEnum["SHOULD"] = "should";
    ElasticsearchFilterTypeEnum["NESTED"] = "nested";
    ElasticsearchFilterTypeEnum["MUST_NOT"] = "must_not";
    ElasticsearchFilterTypeEnum["RANGE"] = "range";
})(ElasticsearchFilterTypeEnum = exports.ElasticsearchFilterTypeEnum || (exports.ElasticsearchFilterTypeEnum = {}));
//# sourceMappingURL=index.js.map